import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPageLock"><Path d="M13.5 16.5H20.5V21.5H13.5V16.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 16C14.5 14.6193 15.6193 13.5 17 13.5C18.3807 13.5 19.5 14.6193 19.5 16V16.5H14.5V16Z" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 21.5H4.5V2.5H19.5V10.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPageLock;
